import { Injectable } from '@angular/core';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import {
  ProductListByIdsConfigService,
  Product
} from 'gung-standard';
import { ColmecTopProductGridViewComponent } from '../components/colmec-top-product-grid-view/colmec-top-product-grid-view.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecTopProductListByIdsConfigService extends ProductListByIdsConfigService {
  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecTopProductGridViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductGrid'
      }
    ];
  }

  getFilters() {
    return [];
  }

  getNothingFoundTranslateTag() {
    return null;
  }

  getSearchGroupCss() {
    return 'd-none';
  }

  getFilterGroupCss() {
    return 'd-none';
  }
}
